import { Routes } from "@angular/router";
import { orgAdminChildRoutes } from "../orgs/org-admin.routes";

/**
 * /super — Classjax-internal staff section. Distinct from /admin (customer
 * org admin). Gated by superGuard (user.is_super === true).
 *
 * /super/orgs reuses the org+campus admin route tree (orgAdminChildRoutes)
 * so supers see the same UI customer org admins do. The list page sits at
 * /super/orgs and lets supers drill into any org regardless of membership.
 */
export const superRoutes: Routes = [
  {
    path: "super",
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./super-dashboard-page/super-dashboard-page.component").then(
            (m) => m.SuperDashboardPageComponent,
          ),
      },
      {
        path: "guides",
        loadComponent: () =>
          import("./guides-list-page/guides-list-page.component").then(
            (m) => m.GuidesListPageComponent,
          ),
      },
      {
        path: "guides/:id",
        loadComponent: () =>
          import("./guide-editor-page/guide-editor-page.component").then(
            (m) => m.GuideEditorPageComponent,
          ),
      },
      {
        path: "curriculum-maps",
        loadComponent: () =>
          import(
            "./curriculum-maps-list-page/curriculum-maps-list-page.component"
          ).then((m) => m.CurriculumMapsListPageComponent),
      },
      // Org directory landing — supers' starting point for org inspection.
      {
        path: "orgs",
        pathMatch: "full",
        loadComponent: () =>
          import("./super-orgs-list-page/super-orgs-list-page.component").then(
            (m) => m.SuperOrgsListPageComponent,
          ),
      },
      // Shared org+campus admin tree, mounted under /super/orgs.
      // Resolves /super/orgs/:orgId, /super/orgs/:orgId/staff, etc.
      {
        path: "",
        children: orgAdminChildRoutes,
      },
    ],
  },
];
